import React from "react";
import { indexStore } from "../../store/indexStore";
import { Route, Routes } from "react-router-dom";
import Restaurant from "../../resturant/ResturantName";
import Branch from "../../resturant/branch/Branch";
import Menu from "../../resturant/branch/menus/Menu";
import Product from "../../resturant/branch/menus/product/Product";
import Cart from "../Cart/Cart";
import Orders from "../Cart/Orders";
import { TableProvider } from "../utils/TableContext";

const RestaurantRoutes: React.FC = () => {
  const { lang } = indexStore();
  return (
    <div
      className={`relative flex flex-col min-h-screen justify-between ${
        lang === "ar" ? "font-almarai" : lang === "en" ? "font-Maven_Pro" : ""
      }`}
    >
      <TableProvider>
        <Routes>
          <Route path="/:domain" element={<Restaurant />} />
          <Route path="/:domain/:branch_id" element={<Branch />} />
          <Route path="/:domain/:branch_id/:menu" element={<Menu />} />
          <Route path="/:domain/:branch_id/cart" element={<Cart />} />
          <Route path="/:domain/:branch_id/orders" element={<Orders />} />
          <Route path="/:domain/:branch_id/popular" element={<Menu />} />
          <Route path="/:domain/:branch_id/new" element={<Menu />} />
          <Route path="/:domain/:branch_id/offers" element={<Menu />} />
          <Route
            path="/:domain/:branch_id/:menu/:product"
            element={<Product />}
          />
        </Routes>
        
      </TableProvider>
    </div>
  );
};

export default RestaurantRoutes;
